/** Membungkus sel yang mengandung koma, kutip, atau baris baru. */
export function csvCell(value: unknown): string {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function rowsToCsv(rows: unknown[][]): string {
  return rows.map((r) => r.map(csvCell).join(',')).join('\n') + '\n';
}

export function downloadCsv(filename: string, content: string | unknown[][]) {
  const text = typeof content === 'string' ? content : rowsToCsv(content);
  // BOM supaya Excel di Windows membaca UTF-8 dengan benar — tanpa ini,
  // "é" dan tanda kutip melengkung berubah jadi karakter rusak.
  const blob = new Blob(['﻿' + text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
